/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import addRegionalProjectActions, {
    addRegionalProjectTypes,
} from '../../../../redux/donneesSocioEconomique/donneesRegionalProject/addRegionalProject'
import { Post } from '../../../../serveur/axios'
import alertActions from '../../../../redux/alert'

function* addRegionalProjectSagas({ response }) {
    try {
        const res = yield Post(`regional-project`, response)
        const { history } = response.props
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    addRegionalProjectActions.addRegionalProjectSuccess(
                        res.data
                    )
                ),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
            ])
            history.push(
                '/formulaires/gestion-des-données/socioéconomiques',
                response.values
            )
        } else {
            yield put(addRegionalProjectActions.addRegionalProjectFailure(res))
        }
    } catch (error) {
        yield put(addRegionalProjectActions.addRegionalProjectFailure(error))
    }
}

export function* addRegionalProjectSaga() {
    yield takeLatest(
        addRegionalProjectTypes.ADD_REGIONAL_PROJECT_REQUEST,
        addRegionalProjectSagas
    )
}
